import DOMHelpers from '../utils/dom-helpers';
import { debounce as _debounce } from 'es-toolkit';
import slideshowSwiper from './slideshowSwiper';
import { gsap } from 'gsap';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default class {

	constructor(options) {

		// OPTIONS
		this.defaults = {
            el: undefined,
            main: undefined,

            debug: false,

            // to close the window if clicked outside the window
            clickOut: true
		}

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = 'window-team-bio';

		// DOM ELEMENT !!!!!!!!!!
		this.el = this.options.el;
        this.main = this.options.main;

		// DOM helpers
		this.dom = new DOMHelpers(document);

		// VARS (vanilla DOM)
		this.window = window;
		this.document = document;
		this.htmlEl = document.documentElement;
		this.body = document.body;

        this.renderOverlay(true);
        

		// init!!!!
		this.init(true);

        if ( this.options.debug ){
            this.open( true, 0 );
        }

	}

	init(b) {
        this.initSlider(b);
		this.addEvents(b);
	}

    renderOverlay(b){
        if ( b ){
            this.body.append( this.el );
        }
        else{
            this.el.remove();
        }
    }


	initSlider(b) {
        const els = this.el.querySelectorAll('.swiper');
        if (!els || els.length === 0) return;
        if (b) {
            els.forEach(el => {
                
                const instance = new slideshowSwiper({ $el: el, main: this.main });
                this.main.WIDGETS.assign(el, instance);

                if ( el.classList.contains( 'slider-bio' ) ){
                    this.sliderBio = instance;
                }
                else{
                    this.sliderBtn = instance;
                }

            });
            this.maxSlides = this.sliderBio.swiper.slides.length;
            if ( this.maxSlides <= 1 ){
                this.dom.addClass( this.el, 'hideNext' );
            }
           
        } else {
            this.main.WIDGETS.destroy(els);
        }
	}

    // this is called when window open, to set immediatly the correct index for sliders
    setSliderIndex( i ){
        let nextIndex = i + 1;
        if ( nextIndex >= this.maxSlides ){
            nextIndex = 0;
        }
        this.sliderBio.swiper.slideToLoop( i, 0 );
        this.sliderBtn.swiper.slideToLoop( nextIndex, 0 );
    }

    // this is called when clik on Slider Btn
    onClickSliderBtn = () => {
        let i = this.sliderBtn.swiper.realIndex;
        // Bio slide to the actual next slide of Btn
        this.sliderBio.swiper.slideToLoop( i );
        // Btn slide next
        this.sliderBtn.swiper.slideNext();
    }

    syncSlidersBtn = () => {
        let i = this.sliderBtn.swiper.realIndex;
        i = i-1;
        if ( i < 0 ){
            i = this.maxSlides - 1;
        }
        this.sliderBio.swiper.slideToLoop( i );
    }

    /*
    syncSlidersBio( ){
        let i = this.sliderBio.swiper.realIndex;
        i = i+1;
        if ( i >= this.maxSlides ){
            i = 0;
        }
        this.sliderBtn.swiper.slideToLoop( i );
    }
    */

	addEvents(b) {
		//this.debounceResize(b);
        if ( b ){
            // close window
            this.dom.on( this.el.querySelector( '.close a' ), 'click', this.closeOverlay );
            // trigger to open window from team grid items
            this.dom.on( this.dom.qsa( '.' + this.el.getAttribute( 'data-trigger' ) ), 'click', this.onClikTeamGridItem );
            // clcik on slider btn for next bio
            this.sliderBtn.swiper.on( 'click', this.onClickSliderBtn );
            // on slide change, if dragged
            this.sliderBtn.swiper.on( 'slideChange', this.syncSlidersBtn );
            //this.sliderBio.swiper.on( 'slideChange', ()=>{ this.syncSlidersBio() } );
            
            // to close the window if clicked outside
            if ( this.options.clickOut ){
                this.dom.on( this.el, 'click', this.onClickOutWindow );
            }
        }
        else{
            this.dom.off( this.el.querySelector( '.close a' ), 'click', this.closeOverlay );
            this.dom.off( this.dom.qsa( '.' + this.el.getAttribute( 'data-trigger' ) ), 'click', this.onClikTeamGridItem );
            this.sliderBtn.swiper.off( 'click', this.onClickSliderBtn );
            this.sliderBtn.swiper.off( 'slideChange', this.syncSlidersBtn );

            if ( this.options.clickOut ){
                this.dom.off( this.el, 'click', this.onClickOutWindow );
            }
        }
        this.addKeyboardEvents(b);
	}

    addKeyboardEvents(b){
        if ( b ){
            document.addEventListener( 'keydown', this.onKeyPress );
        }
        else{
            document.removeEventListener( 'keypress', this.onKeyPress );
        }
    }

    onKeyPress = (e) => {
        switch( e.key ){
            case 'Escape':
                this.open( false );
                break;
        }
    }

    closeOverlay = (e) =>{
        e.preventDefault();
        this.open( false );
    }

    onClickOutWindow = ( e ) =>{
        let id = e.target.getAttribute( 'id' );
        if ( id ){
            if ( id === this.el.getAttribute( 'id' ) ){
                this.open( false );
            }
        }
    }

	debounceResize(b) {
		if (b) {
			// debounce resize
			this._debResize = _debounce(() => this.onResize(true), 17);
			window.addEventListener('resize', this._debResize);
		}
		else {
			if (this._debResize) {
				this._debResize.cancel && this._debResize.cancel();
				window.removeEventListener('resize', this._debResize);
			}
		}
	}

	onResize() {

	}

    // trigger
    onClikTeamGridItem = ( e ) =>{
        e.preventDefault();
        let a = this.dom.parents(e.target, 'a' ), 
        i = 0;
        if ( a ){
            i = parseInt(a[0].getAttribute( 'data-index' ));
        }
        this.open( true, i );
    }

	// public methods //////////////////////////////////////////////////////////////////////////

    open(b,i=0){
        if ( this.dom.hasClass( this.el, 'active' ) === b ){
            return;
        }
        const o = 0.7;
        this.main.pauseScroll(b);
        if ( b ){
            this.dom.addClass( this.el, 'active' );
            this.setSliderIndex( i );
            gsap.fromTo( this.el, {opacity: o}, {opacity:1, y:0, duration:1.1, ease: 'power3.out', onComplete: ()=>{ this.window.dispatchEvent( new Event( 'resize' ) ) } } );
            disableBodyScroll( this.el.querySelector( '.content-scroll' ) );
        }
        else{
            gsap.to( this.el, {opacity: o, y:'110%', duration:0.8, ease: 'power2.out', onComplete: ()=>{ this.dom.removeClass(this.el, 'active') } });
            enableBodyScroll( this.el.querySelector( '.content-scroll' ) );
        }
    }

	destroy() {
		this.init(false);
        this.renderOverlay(false);
	}

}
